import resolveRequest from '../../utils/resolveRequest.js'
import axios from 'axios'
import { apiEndpoints, SERVER_PATH } from '../endpoints'

export const getDistributorUnits = (distributorId, options = { onlyIds: false }) => {
  const endpoint = `${apiEndpoints.distributors}/${distributorId}/machines?onlyIds=${options.onlyIds}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.get(URL, { withCredentials: true }))
}
